import { graphql } from 'gatsby';

import LoadingPage from '~components/LoadingPage/LoadingPage';
import LpChatScript from '~components/LpChatScript/LpChatTag';
import PureBlankFullWidthTemplate from '~components/_templates/PureBlankFullWidthTemplate/PureBlankFullWidthTemplate';
import { getUrlParam } from '~globals/common';
import { RouterLocation } from '~globals/interfaces';
import useAllianceData from '~hooks/useAllianceData';
import { useAppSelector } from '~hooks/useRedux';

export default function PaidSearchBlankFullWidthTemplate({
    location,
    data,
}: {
    data: { wpPage: IWpPage };
    location: RouterLocation;
}) {
    const allianceId = useAppSelector((state) => state.global.allianceId);
    const [allianceResponse, status] = useAllianceData(getUrlParam('allid') || allianceId);

    if (status === 'loading') {
        return <LoadingPage />;
    }

    if (status === 'error') {
        console.warn('allID loading error');
    }

    if (!allianceResponse.partnerAllianceInfo && typeof window !== 'undefined') {
        console.warn('allID did not return partner data');
    }

    return <PureBlankFullWidthTemplate location={location} data={data.wpPage} />;
}

export const query = graphql`
    query ($id: String!) {
        wpPage(id: { eq: $id }) {
            acfPage {
                ppccPageCode
            }
            featuredImage {
                node {
                    srcSet
                    uri
                }
            }
            template {
                templateName
            }
            id
            link
            modified
            title
            uri
            slug
            content
            seo {
                title
                metaDesc
                focuskw
                metaKeywords
                metaRobotsNoindex
                metaRobotsNofollow
                opengraphTitle
                opengraphDescription
                opengraphImage {
                    altText
                    sourceUrl
                    srcSet
                    height
                    width
                }
                twitterTitle
                twitterDescription
                twitterImage {
                    altText
                    sourceUrl
                    srcSet
                }
                canonical
                cornerstone
                schema {
                    articleType
                    pageType
                    raw
                }
                fullHead
                opengraphAuthor
                opengraphModifiedTime
                opengraphPublishedTime
                opengraphPublisher
                opengraphSiteName
                opengraphType
                opengraphUrl
                readingTime
            }
            wpChildren {
                nodes {
                    ... on WpPage {
                        uri
                        title
                    }
                }
            }
        }
    }
`;

export const Head = () => (
    <>
        <LpChatScript />
    </>
);
